var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 30,
    height: 30,
    baseProfile: "tiny",
    viewBox: "0 0 30 30",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#5e9d6e",
    fillRule: "evenodd",
    d: "M12.5 18c1.4 0 2.5-1.1 2.5-2.5S13.9 13 12.5 13 10 14.1 10 15.5s1.1 2.5 2.5 2.5m0-4c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5-1.5-.7-1.5-1.5.7-1.5 1.5-1.5M15 0C6.7 0 0 6.7 0 15s6.7 15 15 15 15-6.7 15-15S23.3 0 15 0m0 29C7.3 29 1 22.7 1 15S7.3 1 15 1s14 6.3 14 14-6.3 14-14 14m-2.5-10c-3 0-5.5 1.7-5.5 2.9v.8c0 .7.5 1.3 1.2 1.3h8.6c.7 0 1.2-.6 1.2-1.2V22c0-1.3-2.5-3-5.5-3m4.5 3.3c0 .4-.4.7-1 .7H9c-.6 0-1-.3-1-.7v-.5c0-.8 2-1.8 4.5-1.8s4.5 1 4.5 1.7zM19 12l-2-2h-1v1l3 3 5-5V8h-1z"
  })));
});
const SvgAutoApprovedStepIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAutoApprovedStepIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNy4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4yIiBiYXNlUHJvZmlsZT0idGlueSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiDQoJIHg9IjBweCIgeT0iMHB4IiB3aWR0aD0iMzBweCIgaGVpZ2h0PSIzMHB4IiB2aWV3Qm94PSIwIDAgMzAgMzAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBmaWxsPSIjNWU5ZDZlIiBkPSJNMTIuNSwxOGMxLjQsMCwyLjUtMS4xLDIuNS0yLjVTMTMuOSwxMywxMi41LDEzYy0xLjQsMC0yLjUsMS4xLTIuNSwyLjUNCglTMTEuMSwxOCwxMi41LDE4eiBNMTIuNSwxNGMwLjgsMCwxLjUsMC43LDEuNSwxLjVjMCwwLjgtMC43LDEuNS0xLjUsMS41Yy0wLjgsMC0xLjUtMC43LTEuNS0xLjVDMTEsMTQuNywxMS43LDE0LDEyLjUsMTR6IE0xNSwwDQoJQzYuNywwLDAsNi43LDAsMTVjMCw4LjMsNi43LDE1LDE1LDE1YzguMywwLDE1LTYuNywxNS0xNUMzMCw2LjcsMjMuMywwLDE1LDB6IE0xNSwyOUM3LjMsMjksMSwyMi43LDEsMTVDMSw3LjMsNy4zLDEsMTUsMQ0KCWM3LjcsMCwxNCw2LjMsMTQsMTRDMjksMjIuNywyMi43LDI5LDE1LDI5eiBNMTIuNSwxOWMtMywwLTUuNSwxLjctNS41LDIuOWMwLDAuMiwwLDAuOCwwLDAuOEM3LDIzLjQsNy41LDI0LDguMiwyNGg4LjYNCgljMC43LDAsMS4yLTAuNiwxLjItMS4yYzAsMCwwLTAuNiwwLTAuOEMxOCwyMC43LDE1LjUsMTksMTIuNSwxOXogTTE3LDIyLjNjMCwwLjQtMC40LDAuNy0xLDAuN0g5Yy0wLjYsMC0xLTAuMy0xLTAuNw0KCWMwLDAsMC0wLjQsMC0wLjVDOCwyMSwxMCwyMCwxMi41LDIwYzIuNSwwLDQuNSwxLDQuNSwxLjdDMTcsMjEuOSwxNywyMi4zLDE3LDIyLjN6IE0xOSwxMmwtMi0yaC0xdjFsMywzbDUtNVY4aC0xTDE5LDEyeiIvPg0KPC9zdmc+DQo=";